"use client";
// import { Input } from "@heroui/input";
import React, { startTransition, useEffect, useState } from "react";
import { ErrorMap } from "@/types/index";
import { z } from "zod";
import axios from "axios";
import { useModal } from "@/components/modal-context";
import FailModal from "@/components/modals/fail-modal";
import { useRouter, Link } from "@/i18n/routing";
import { Button, PasswordInput, Input } from "@/components/custom";
import { useTranslations } from "next-intl";
import { LoginAction } from "@/lib/actions";
import Image from "next/image";
import { InputCheck } from "@/lib/helper";
export default function loginPage() {
  const { openModal } = useModal();
  const router = useRouter();
  const t = useTranslations();
  const [username, setUsername] = useState<string>("");

  const [errors, setErrors] = useState<ErrorMap>({});
  const loginSchema = z.object({
    username: z.string().min(1, t("username-is-required")),
    password: z.string().min(1, t("password-is-required")),
  });

  const formHandler = async (formData: FormData) => {
    const res = loginSchema.safeParse({
      username: formData.get("username"),
      password: formData.get("password"),
    });

    if (!res.success) {
      // convert zod res into error map {fieldName:error}
      const errorMap = res.error.errors.reduce((acc: ErrorMap, err) => {
        acc[err.path[0] as string] = err.message;
        return acc;
      }, {} as ErrorMap);
      setErrors(errorMap);
      return;
    }

    setErrors({});
    try {
      const loginRes = await LoginAction(formData.get("username") as string, formData.get("password") as string);
      if (loginRes.status_code !== 0) {
        openModal(
          <FailModal description={t("username-or-password-is-incorrect-please-try-again")} />,
          t("failed-to-login")
        );
      } else {
        localStorage.setItem("post-logged-modal", "true");
        router.push("/");
      }
    } catch (e) {
      openModal(
        <FailModal description={t("username-or-password-is-incorrect-please-try-again")} />,
        t("failed-to-login")
      );
      // openModal(<FailModal description="unexpected error" />, "Failed to login");
    }
  };

  return (
    <div className="flex w-full flex-col gap-y-4">
      <Image
        src="/banner/auth/login.png"
        className="w-full rounded-2xl border-2 border-solid border-transparent bg-gradient-to-r from-[#FFEA92] via-[#C9A04C] to-[#FFFFA5] bg-clip-border shadow-2xl"
        alt="ads"
        width={1500 / 3}
        height={690 / 3}
      />
      <h1 className="text-center text-2xl font-bold">{t("sign-in")}</h1>
      {/* Change the form handler from onSubmit to action */}
      {/* Benefit of using action attribute with the combination of useFormStatus() hook, is react able to track the action progress. */}
      {/* Check the custom made <Button/> bellow. */}
      <form
        className="flex w-full flex-col gap-y-3"
        action={formHandler}
        onFocus={() => {
          setErrors({});
        }}
      >
        <Input
          name="username"
          value={username}
          onValueChange={(e) => setUsername(InputCheck.username.format(e))}
          isInvalid={!!errors.username}
          errorMessage={errors.username}
          label={t("username")}
        />
        {/* This is useful because you don't have to make multiple useState() to toggle the visibility of the password. Imagine you have 4 password input, it will become very messy. */}
        <PasswordInput
          name="password"
          isInvalid={!!errors.password}
          errorMessage={errors.password}
          label={t("password")}
        />
        <Button type="submit" isForm className="w-full bg-[#258966] disabled:bg-gray-600">
          {t("login-now")}
        </Button>
      </form>
      <div className="mt-5 flex flex-col items-center justify-center gap-y-5">
        {/* <Link href="/forgot-password" className="text-[#258966]">
          Forgot password?
        </Link> */}
        <div className="flex flex-row gap-x-1 text-sm">
          <p>{t("dont-have-an-account")} </p>
          <Link href="/register" className="text-[#258966]">
            {t("sign-up")}
          </Link>
        </div>
      </div>
    </div>
  );
}
